import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import LanguageSelector from './Entities/LanguageSelector';
import logo from './assets/logotypes/logo_white.png';
import './styles/Header.css';

function Header() {
  const { translations } = useLanguage();
  const navigate = useNavigate();
  const [profileOpen, setProfileOpen] = useState(false);
  const profileBtnRef = useRef(null);
  const profileMenuRef = useRef(null);

  const handleNavigate = (path) => {
    navigate(path);
    setProfileOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        profileBtnRef.current &&
        !profileBtnRef.current.contains(event.target) &&
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target)
      ) {
        setProfileOpen(false);
      }
    }
    if (profileOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [profileOpen]);

  return (
    <header className="header-container">
      <div className="icon-group left">
        <span className="header-icon" title="Help" onClick={() => navigate('/help')}>
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
            <line x1="12" y1="17" x2="12" y2="17"/>
          </svg>
        </span>
      </div>
      <div className="logo-center">
        <img
          src={logo}
          className="logo-image clickable-logo"
          alt="Logo"
          onClick={() => navigate('/home')}
          style={{ cursor: 'pointer' }}
        />
      </div>
      <div className="icon-group right">
        <LanguageSelector />
        <div className="profile-dropdown-container">
          <span
            className="header-icon"
            title="Menu"
            onClick={() => setProfileOpen(!profileOpen)}
            ref={profileBtnRef}
          >👤
          </span>
          {profileOpen && (
            <div className="profile-dropdown-menu" ref={profileMenuRef}>
              <div className="menu-item" onClick={() => handleNavigate('/users/profileSettings')}>
                <span className="sidebar-icon">✏️</span>
                {translations.edit_profile}
              </div>
              <div className="menu-item" onClick={() => handleNavigate('/forgotPassword')}>
                <span className="sidebar-icon">🔑</span>
                {translations.change_password}
              </div>
              <div className="menu-item" onClick={() => handleNavigate('/customPlants')}>
                <span className="sidebar-icon">🌱</span>
                {translations.custom_plants}
              </div>
              <div className="menu-item logout" onClick={() => handleNavigate('/logout')}>
                {translations.logout}
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
